import React from 'react'

import FormError from "../../../gd-form/common/form-error/form-error"
import FormManager from "../../../gd-form/common/form-manager"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import FieldFormElement from "../../../fields3/render/form-elemnent"

type Props = {
    form: FormManager
}

export default function CustomFieldAccess(props: Props) {

    return (
        <FormRowFlex  field={gd.fields.customFields.access}>
            <div className="flex-column-left-top">
                <FieldFormElement className = "w-300"
                                  field     = {gd.fields.customFields.access}
                                  form      = {props.form}/>

                <FormError form = {props.form}
                           name = {gd.fields.customFields.access.fieldId}/>
            </div>
        </FormRowFlex>
    )
}
